import type { ReactElement, ReactNode } from "react"
import ContainerOrg from "@onestore/hel/dist/components/organisms/ContainerOrg"
import SurfaceOrg from "@onestore/hel/dist/components/organisms/SurfaceOrg"
import type { CustomColor } from "@gatsby-plugin-generic-page/fragments/customColor"
import type { ThemeBackgroundColor } from "@gatsby-plugin-generic-page/fragments/themeBackgroundColor"
import getBackground from "@gatsby-plugin-generic-page/helpers/getBackground"

const surfaceSpacing = {
  small: {
    horizontal: 0,
    vertical: 2,
  },
  medium: {
    horizontal: 0,
    vertical: 2,
  },
  large: {
    horizontal: 1,
    vertical: 4,
  },
}

const surfaceSpacingWithHeader = {
  small: {
    horizontal: 0,
    vertical: 4,
  },
  medium: {
    horizontal: 0,
    vertical: 4,
  },
  large: {
    horizontal: 1,
    vertical: 6,
  },
}

type DomainSearchSwitchElementProps = {
  children: ReactNode
  backgroundColor?: ThemeBackgroundColor | CustomColor
  hasHeader?: boolean
  isContentWide?: boolean
}

function DomainSearchSurfaceElement({
  children,
  backgroundColor,
  hasHeader = false,
  isContentWide = false,
}: DomainSearchSwitchElementProps): ReactElement<DomainSearchSwitchElementProps> {
  const { backgroundThemeColor, customColor, customOnColorText } =
    getBackground(backgroundColor)

  return (
    <SurfaceOrg
      spacingSpace={hasHeader ? surfaceSpacingWithHeader : surfaceSpacing}
      customColor={customColor?.background}
      color={backgroundThemeColor || customOnColorText}
      borderRadiusSize="sm"
    >
      <ContainerOrg width={isContentWide ? "default" : "medium"}>
        {children}
      </ContainerOrg>
    </SurfaceOrg>
  )
}

export default DomainSearchSurfaceElement
